<template>
<div>
  <div>
    <Header />
    <div class="mx-4">
      <NavBar v-if="$route.name !== 'Accounts'"/>
    </div>
    <v-touch class="content" :swipe-options="{direction: 'horizontal'}">
      <!--<breadcrumb-history></breadcrumb-history>-->
      <transition name="router-animation">
        <router-view />
      </transition>
      <footer class="contentFooter fixed-bottom text-center">
      </footer>
    </v-touch>
  </div>
  <div>
    <b-modal id="modal-first-contact-email" ref="modal-first-contact-email" size="xl" hide-footer hideHeaderClose no-close-on-esc no-close-on-backdrop>
      <div>
        <CGU :cgu="cgu" :contacts="contacts" :company="company"></CGU>
      </div>
    </b-modal>
  </div>
</div>
</template>

<script>
import logger from '@/utils/func/logger'
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('layout');

import Header from '@/components/Header/Header';
import NavBar from '@/components/NavBar/NavBar';
import BreadcrumbHistory from '@/components/BreadcrumbHistory/BreadcrumbHistory';
import CGU from "@/components/CGU/CGU";

import './Layout.scss';

export default {
  name: 'Layout',
  components: { Header, BreadcrumbHistory, NavBar, CGU },
  data() {
    return {
      isLoadingUpdateContact: false,
      isConditionValidated: true,
      contacts: null,
      company: null,
      cgu: ''
    }
  },
  methods: {
    ...mapActions([
      'switchSidebar',
      'handleSwipe',
      'changeSidebarActive',
      'toggleSidebar'
    ]),
    handleWindowResize() {
      const width = window.innerWidth;
      if (width <= 768 && this.sidebarStatic) {
        this.toggleSidebar();
        this.changeSidebarActive(null);
      }
    },
    countNbAgent () {
      this.$store.dispatch('tenant/countNbAgent')
        .then((res) => {
          logger.log('SUCCESS countNbAgent', res);
          if (res.nb_agent === 0) {
            this.$router.push('/app/installation');
          }
        })
        .catch((err) => {
          logger.error('Err call countNbAgent', err);
        });
    },
    isContactEmailConfigured() {
      this.$store.dispatch('configuration/isContactEmailConfigured')
        .then((res) => {
          logger.log('SUCCESS isContactEmailConfigured', res);
          this.cgu = res.cgu;
          this.isConditionValidated = res.is_condition_validated ? true : false;
          if (!this.isConditionValidated) {
            this.contacts = res.contacts;
            this.company = res.company;
            this.$bvModal.show('modal-first-contact-email');
            localStorage.setItem('cgu', true);
          }
        })
        .catch((err) => {
          logger.error('Err call isContactEmailConfigured', err);

        })
    }
  },
  computed: {
    ...mapState([
      "sidebarClose",
      "sidebarStatic"
    ]),
    isCollaborator() {
      return localStorage.getItem('user.role') === 'COLLABORATOR';
    },
  },
  created() {
    if (localStorage.getItem('cgu')) {
      localStorage.removeItem('cgu');
    }
    const staticSidebar = JSON.parse(localStorage.getItem('sidebarStatic'));

    if (staticSidebar) {
      this.$store.state.layout.sidebarStatic = true;
    } else if (!this.sidebarClose) {
      setTimeout(() => {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      }, 2500);
    }

    this.handleWindowResize();
    window.addEventListener('resize', this.handleWindowResize);

    if (localStorage.getItem('token') == null) {
      window.open(process.env.VUE_APP_ORANGE_PRO_APP,'_self');
    } else {
      if (!this.isCollaborator) {
        this.countNbAgent();
      }
    }
    if (!this.isCollaborator) {
      this.isContactEmailConfigured();
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  }
};
</script>

<style src="./Layout.scss" lang="scss" />